export default "__VITE_ASSET__18af3ac8__"